import React, { useState } from 'react';
import FocusLock from 'react-focus-lock';
import './DeleteAccountModal.css';

function DeleteAccountModal({ isOpen, onClose, onConfirm, loading }) {
  const [confirmText, setConfirmText] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (confirmText.toLowerCase() !== 'delete') {
      setError('Please type "delete" to confirm');
      return;
    }
    
    setError('');
    onConfirm();
  };

  const handleClose = () => {
    if (!loading) {
      setConfirmText('');
      setError('');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <FocusLock returnFocus>
        <div 
          className="delete-account-modal" 
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-labelledby="delete-modal-title"
        >
          <div className="modal-header">
            <h2 id="delete-modal-title">Delete Account</h2>
            <button
              onClick={handleClose}
              className="modal-close-btn"
              disabled={loading}
              aria-label="Close modal"
            >
              ×
            </button>
          </div>

          <div className="modal-body">
            <div className="warning-message">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              <h3>This action cannot be undone</h3>
            </div>

            <p>
              Deleting your account will permanently remove all your personal information from our system. 
              Your posts and content will remain visible but will be attributed to "Inactive User".
            </p>

            <p className="warning-text">
              <strong>What will be deleted:</strong>
            </p>
            <ul className="delete-list">
              <li>Your profile information</li>
              <li>Your email and login credentials</li>
              <li>Your account settings</li>
              <li>All personal data</li>
            </ul>

            <p className="warning-text">
              <strong>What will be preserved:</strong>
            </p>
            <ul className="preserve-list">
              <li>Your content and posts (anonymized)</li>
              <li>Your comments (anonymized)</li>
            </ul>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="confirm-delete">
                  Type <strong>delete</strong> to confirm:
                </label>
                <input
                  type="text"
                  id="confirm-delete"
                  value={confirmText}
                  onChange={(e) => setConfirmText(e.target.value)}
                  placeholder="Type 'delete' here"
                  className="form-input"
                  disabled={loading}
                  autoComplete="off"
                  autoFocus
                />
                {error && (
                  <span className="field-error" role="alert">{error}</span>
                )}
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  onClick={handleClose}
                  className="btn btn-secondary"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-danger"
                  disabled={loading || confirmText.toLowerCase() !== 'delete'}
                >
                  {loading ? 'Deleting Account...' : 'Delete My Account'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </FocusLock>
    </div>
  );
}

export default DeleteAccountModal;
